// "Sign in to continue": a modal <dialog> over Submit when a signed-out viewer submits a batch (POST /v1/jobs/bulk is for
// signed-in users) or the backend answers it with 401. The GitHub sign-in is a plain link back to Submit; a file selection
// cannot survive that round trip, so the files are chosen again afterwards.
//   <SignInDialog open href onClose />
import { useEffect, useRef } from "react";
import { Icon, buttonClass } from "@/components/ui";

export function SignInDialog({ open, href, onClose }: { open: boolean; href: string; onClose: () => void }) {
  const ref = useRef<HTMLDialogElement>(null);

  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) d.showModal();
    else if (!open && d.open) d.close();
  }, [open]);

  return (
    <dialog
      ref={ref}
      aria-labelledby="signin-title"
      onClose={onClose}
      // the dialog owns the keyboard while open: page and global shortcuts stay behind it
      onKeyDown={(e) => e.stopPropagation()}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose(); // the backdrop
      }}
      className="m-auto w-[min(440px,calc(100vw-32px))] border border-rule-strong bg-raised p-0 text-ink shadow-pop backdrop:bg-paper/70 open:transition-[opacity,translate] open:duration-160 open:ease-out starting:open:translate-y-1 starting:open:opacity-0"
    >
      <div className="px-6 pt-5 pb-6">
        <div className="flex items-baseline justify-between gap-4">
          <p className="lens-eyebrow">Bulk submission</p>
          <button type="button" className="copy-text" onClick={onClose}>
            close <kbd>Esc</kbd>
          </button>
        </div>
        <h2 id="signin-title" className="dialog-title mt-2">
          Sign in to continue
        </h2>
        <p className="meta mt-2">Several files or an archive need a signed-in account · choose them again after signing in</p>
        <div className="mt-5 flex flex-wrap items-center gap-2.5">
          {/* the dialog opens on its action */}
          <a className={buttonClass({ variant: "cta", size: "lg" })} href={href} autoFocus>
            <Icon name="github" size={14} />
            Sign in with GitHub
          </a>
          <button type="button" className={buttonClass({ variant: "ghost", size: "lg" })} onClick={onClose}>
            Cancel
          </button>
        </div>
      </div>
    </dialog>
  );
}
